import PropTypes from 'prop-types';

import CustomSVGIcon from './CustomSVGIcon';

const Crown = ({ color = '', ...other }) => {
	return (
		<CustomSVGIcon {...other}>
			<path
				d="M9.92,6 C10.1299776,6 10.3017883,6.15316746 10.3151972,6.34680482 L12.9481202,10.9520994 L17.1287632,7.23771391 C17.1421721,7.04407655 17.3139828,6.89090909 17.5239604,6.89090909 C17.742687,6.89090909 17.92,7.05710642 17.92,7.26212121 L16.3358416,17.4757576 C16.3358416,18.798711 15.2500405,19.8839601 13.8681661,19.9912847 L6.19722772,20 C4.72698249,20 3.53191351,18.8956891 3.50463491,17.5237241 L1.92,7.26212121 C1.92,7.05710642 2.09731297,6.89090909 2.3160396,6.89090909 C2.52601717,6.89090909 2.69782791,7.04407655 2.7112368,7.23771391 L7.06714942,10.9520994 L9.5248028,6.34680482 C9.5382117,6.15316746 9.71002243,6 9.92,6 Z M9.966,9.767 L7.66114412,14.087023 L4.593,11.471 L5.50158524,17.3504615 L5.5042397,17.4839662 C5.50933605,17.7402852 5.79132431,18 6.19722772,18 L13.756,17.991 L13.8219451,17.9821341 C14.1007744,17.9252404 14.2899488,17.7414171 14.3285453,17.5483579 L14.3358416,17.4757576 L14.3358416,17.321577 L15.222,11.607 L12.4346812,14.0836321 L9.966,9.767 Z M2,2 C3.1045695,2 4,2.8954305 4,4 C4,5.1045695 3.1045695,6 2,6 C0.8954305,6 0,5.1045695 0,4 C0,2.8954305 0.8954305,2 2,2 Z M18,2 C19.1045695,2 20,2.8954305 20,4 C20,5.1045695 19.1045695,6 18,6 C16.8954305,6 16,5.1045695 16,4 C16,2.8954305 16.8954305,2 18,2 Z M10,1 C11.1045695,1 12,1.8954305 12,3 C12,4.1045695 11.1045695,5 10,5 C8.8954305,5 8,4.1045695 8,3 C8,1.8954305 8.8954305,1 10,1 Z"
				id="crown"
				fill={color}
			/>
		</CustomSVGIcon>
	);
};

Crown.propTypes = {
	color: PropTypes.string,
};

export default Crown;
